import type { RumEvent } from '@datadog/browser-rum';
import type { EventFilter } from '@ringba/core/telemetry';
import { maskIdSegment } from './idSegments';

/** Replaces each `-`-separated part of an action's name that contains a digit with `?`, so a test id that embeds an id names one action. */
export function maskActionNameIds(): EventFilter<RumEvent> {
  return (event) => {
    const target = event.type === 'action' ? event.action.target : undefined;
    if (target) target.name = target.name.split('-').map(maskIdSegment).join('-');
    return true;
  };
}
